"use strict";

import Page from "./StripeAccountSetup.jsx";

export const auth = true;
export const title = "i18n:myAccount.accountInformation";
export const Component = Page;
